import { z } from 'zod';
/** Per-layer override — every field optional; templated.io ignores unknown
 *  ones gracefully. We accept arbitrary string keys so adding a new layer
 *  property doesn't require a schema change. */
const TemplateLayerFillSchema = z
    .object({
    text: z.string().max(20_000).optional(),
    color: z.string().max(50).optional(),
    font_family: z.string().max(100).optional(),
    font_size: z.string().max(20).optional(),
    font_weight: z.string().max(20).optional(),
    background: z.string().max(50).optional(),
    image_url: z.string().url().max(2_000).optional(),
})
    .passthrough();
const TemplateLayersPayloadSchema = z
    .record(z.string().min(1).max(200), TemplateLayerFillSchema)
    .refine((d) => Object.keys(d).length > 0, {
    message: 'At least one layer fill must be provided',
});
export const CreateTemplateFillRequestSchema = z.object({
    templateId: z.string().min(1).max(200),
    layers: TemplateLayersPayloadSchema,
    format: z.enum(['jpg', 'png', 'webp', 'pdf', 'mp4']).optional(),
});
export const SetTemplatedKeyRequestSchema = z.object({
    apiKey: z.string().trim().min(8).max(500),
});
export const PatchTemplateFillConfigRequestSchema = z
    .object({
    driveFolderInput: z.string().max(500).nullable().optional(),
    r2BucketName: z.string().max(200).nullable().optional(),
    r2Folder: z.string().max(200).nullable().optional(),
})
    .refine((d) => Object.keys(d).length > 0, {
    message: 'At least one field must be provided',
});
export const GrantTemplateFillBodySchema = z.object({
    userId: z.string().uuid(),
});
/**
 * Share — package selected generations into mail attachments and route via
 * internal mail. Capped at 5 by MAIL_LIMITS.maxAttachments.
 */
export const ShareTemplateFillRequestSchema = z.object({
    generationIds: z.array(z.string().uuid()).min(1).max(5),
    recipientUserIds: z.array(z.string().uuid()).min(1).max(50),
});
export const TemplateFillGenerationIdParamSchema = z.object({
    id: z.string().uuid(),
});
export const TemplatedTemplateIdParamSchema = z.object({
    id: z.string().min(1).max(200),
});
//# sourceMappingURL=template-fill.schema.js.map